import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import instance from "../instance"; // Your Axios instance


export const useBulkUploadUsers=()=>{
    const mutation = useMutation(async(payload)=>{
        const {data}= await instance.post(`/api/user-bulk-upload`, payload, {
            headers:{
                "Content-Type":"multipart/form-data"
            }
        })
        return data
    })
return mutation
}
export const useBulkUploadLocation=()=>{
    const mutation = useMutation(async(payload)=>{
        const {data}= await instance.post(`/api/locations-bulk-upload`, payload, {
            headers:{
                "Content-Type":"multipart/form-data"
            }
        })
        return data
    })
return mutation
}
export const useBulkUploadAssignment=()=>{
    const mutation = useMutation(async(payload)=>{
        const {data}= await instance.post(`/api/bulk-upload`, payload, {
            headers:{
                "Content-Type":"multipart/form-data"
            }
        })
        return data
    })
return mutation
}